import { useSelector } from 'react-redux';

import { Roles } from 'modules/Users/models/role';
import { selectUser } from 'modules/Users/selectors';

export default function useIsReader(): boolean {
  const { role } = useSelector(selectUser);
  return role?.name === Roles.READER;
}
